import { createStore, createEvent } from "effector"

interface PendingAssetSidebarState {
    assetId: string | null
    onReservationDelete?: () => void
}

// Events
export const setPendingAssetSidebar = createEvent<{
    assetId: string
    onReservationDelete?: () => void
}>()

export const clearPendingAssetSidebar = createEvent()

// Store
export const $pendingAssetSidebar = createStore<PendingAssetSidebarState>({
    assetId: null,
    onReservationDelete: undefined
})
    .on(setPendingAssetSidebar, (_, payload) => ({
        assetId: payload.assetId,
        onReservationDelete: payload.onReservationDelete
    }))
    .on(clearPendingAssetSidebar, () => ({
        assetId: null,
        onReservationDelete: undefined
    }))

export default {
    $pendingAssetSidebar,
    setPendingAssetSidebar,
    clearPendingAssetSidebar
}
